/**
 * Invoiced Tab
 */

import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

export const InvoicedSettingsState = {
  invoicedEnableDetails: false,
  invoicedSettings: {},
  invoicedSettingsLoading: false,
}

export const InvoicedSettingsActions = {
  createInvoicedSettings: async ({ commit }, value) => {
    commit('setInvoicedSettingsLoading', true)

    return axiosRequest.
      post('/admin/site_settings', {
        name: 'invoiced',
        value,
      }).
      then(({ data }) => {
        commit('setInvoicedEnableDetails', false)
        commit('setInvoicedSettings', data)
        return data
      }).
      catch(handleError).
      finally(_ => commit('setInvoicedSettingsLoading', false))
  },

  getInvoicedSettings: async ({ commit }) => {
    commit('setInvoicedSettingsLoading', true)

    return axiosRequest.
      get('/admin/site_settings/invoiced').
      then(({ data }) => {
        commit('setInvoicedEnableDetails', false)
        commit('setInvoicedSettings', data)
        return data
      }).
      catch(handleError).
      finally(_ => commit('setInvoicedSettingsLoading', false))
  },

  updateInvoicedSettings: async ({ getters, commit }, value) => {
    commit('setInvoicedSettingsLoading', true)

    return axiosRequest.
      put(`/admin/site_settings/${getters.invoicedSettingsId}`, {
        name: 'invoiced',
        value,
      }).
      then(({ data }) => {
        commit('setInvoicedEnableDetails', false)
        commit('setInvoicedSettings', data)
        return data
      }).
      catch(handleError).
      finally(_ => commit('setInvoicedSettingsLoading', false))
  },

  deleteInvoicedSettings: async ({ getters, commit }) => {
    commit('setInvoicedSettingsLoading', true)

    return axiosRequest.
      delete(`/admin/site_settings/${getters.invoicedSettingsId}`).
      then(({ data }) => {
        commit('setInvoicedEnableDetails', false)
        commit('setInvoicedSettings', data)
        return data
      }).
      catch(handleError).
      finally(_ => commit('setInvoicedSettingsLoading', false))
  },

  clearInvoicedSettings: ({ commit }) => {
    commit('setInvoicedSettings', null)
  },

  setInvoicedEnableDetails: ({ commit }, value) => {
    commit('setInvoicedEnableDetails', value)
  },
}

export const InvoicedSettingsMutations = {
  setInvoicedEnableDetails: (state, payload) => { state.invoicedEnableDetails = payload },
  setInvoicedSettings: (state, payload) => { state.invoicedSettings = payload },
  setInvoicedSettingsLoading: (state, payload) => { state.invoicedSettingsLoading = payload },
  setInvoicedSettingsValue: (state, payload) => { state.invoicedSettings.value = payload },
}

export const InvoicedSettingsGetters = {
  invoicedEnableDetails: state => state.invoicedEnableDetails,
  invoicedSettings: state => state.invoicedSettings,
  invoicedSettingsId: state => state.invoicedSettings?.id,
  invoicedSettingsLoading: state => state.invoicedSettingsLoading,
  invoicedSettingsValue: state => state.invoicedSettings?.value,
}
